import clamp from 'lodash-es/clamp'

import { isValueFunctionType, isValueNumberType } from '../../utils/common'

function getMaxWidth({ containerRef, currentWidth, maxWidth }) {
  switch (true) {
    case isValueFunctionType(maxWidth):
      return maxWidth({
        containerElement: containerRef?.current ?? null,
        currentWidth,
      })
    case isValueNumberType(maxWidth):
      return maxWidth

    default:
      return Infinity
  }
}

export function getResolvedMaxWidth({
  containerRef,
  currentWidth,
  maxWidth,
  maxWidthRatioToContainer,
}) {
  const resolvedMaxWidth = getMaxWidth({ containerRef, currentWidth, maxWidth })

  if (
    isValueNumberType(maxWidthRatioToContainer) &&
    Number.isFinite(maxWidthRatioToContainer) &&
    containerRef?.current
  ) {
    const containerWidth = containerRef.current.getBoundingClientRect().width

    return Math.min(resolvedMaxWidth, containerWidth * maxWidthRatioToContainer)
  }

  return resolvedMaxWidth
}

export function getResolvedMinWidth({ currentWidth, minWidth }) {
  switch (true) {
    case isValueFunctionType(minWidth):
      return minWidth({ currentWidth })
    case isValueNumberType(minWidth):
      return minWidth

    default:
      return 0
  }
}

export function getResolvedNextWidth({
  containerRef,
  currentX,
  getNextWidth,
  maxWidth,
  maxWidthRatioToContainer,
  minWidth,
  startWidth,
  startX,
}) {
  const deltaX = currentX - startX

  const rawNextWidth = getNextWidth
    ? getNextWidth({
        currentX,
        deltaX,
        startWidth,
        startX,
      })
    : startWidth - deltaX

  return clamp(
    rawNextWidth,
    getResolvedMinWidth({ currentWidth: rawNextWidth, minWidth }),
    getResolvedMaxWidth({
      containerRef,
      currentWidth: rawNextWidth,
      maxWidth,
      maxWidthRatioToContainer,
    })
  )
}
